import { Component, Input } from '@angular/core';

export type paddingType = 'no-padding' | 'small-padding' | 'medium-padding';

@Component({
  selector: 'app-responsive-layout',
  templateUrl: './responsive-layout.component.html',
  styleUrls: ['./responsive-layout.component.scss']
})
export class ResponsiveLayoutComponent {
  // title text that need to rendered
  @Input() titleKey!: string;

  // overline text that need to rendered if undefined then it will not be shown
  @Input() overline!: string;

  // this is used to adjust padding
  @Input() paddingType!: paddingType;

  /**
   * Will return class name according to the input provided
   *
   * @returns {string}
   */
  getClass = () => {
    switch (this.paddingType) {
      case 'no-padding':
        return 'no-padding';
      case 'small-padding':
        return 'small-padding';
      case 'medium-padding':
        return 'medium-padding';
      default:
        return '';
    }
  };
}
